import * as types from "../../actions/actionTypes";

const initialState = {
  data: {},
  loading: true,
  error: "",

  itemData: {},
  itemLoading: false,
  itemError: ""
};

const PettyCashierPettyCashBudget = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        loading: false
      };
    case types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_REQUEST:
      return { ...state, itemLoading: true, itemData: {}, itemError: "" };
    case types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_SUCCESS:
      return { ...state, itemData: action.payLoad, itemLoading: false };
    case types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_FAILURE:
      return { ...state, itemLoading: false, itemError: action.error };

    default:
      return state;
  }
};

export default PettyCashierPettyCashBudget;
